<template>
  <div class="pc-home">
    <!-- PC端头部 -->
    <header class="pc-header">
      <div class="header-container">
        <div class="logo">
          <img src="/img/study.png" alt="logo" class="logo-img" />
          <span class="logo-title">上岸</span>
        </div>
        <nav class="nav-menu">
          <a href="#" class="nav-item active">首页</a>
          <a href="#project" class="nav-item">课程</a>
          <a href="#about" class="nav-item">关于我们</a>
        </nav>
        <div class="user-actions">
          <span class="user-name">
            欢迎您，{{ userName ? userName : '请登录' }}
          </span>
          <button class="btn-mine-outline" @click="goMine">
            我的
          </button>
        </div>
      </div>
    </header>

    <!-- PC端Banner轮播图 -->
    <section class="pc-banner">
      <div class="banner-container">
        <div class="banner-slider" ref="bannerSlider">
          <div class="banner-slide" v-for="(item, index) in slider" :key="index" :class="{ active: currentSlide === index }">
            <img :src="`/img/0${item}.jpg`" :alt="`Banner ${index + 1}`" class="banner-image">
            <div class="banner-content">
              <h2 class="banner-title">专业课程，助你上岸</h2>
              <p class="banner-desc">精选优质课程，助力学习成长</p>
              <a href='#project'><button class="banner-btn">立即学习</button></a>
            </div>
          </div>
        </div>
        <div class="banner-dots">
          <span 
            v-for="(item, index) in slider" 
            :key="index" 
            class="dot" 
            :class="{ active: currentSlide === index }"
            @click="goToSlide(index)"
          ></span>
        </div>
        <button class="banner-arrow prev" @click="prevSlide">‹</button>
        <button class="banner-arrow next" @click="nextSlide">›</button>
      </div>
    </section>

    <!-- PC端分类展示 -->
    <section class="pc-categories" id="project">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">课程分类</h2>
          <p class="section-desc">选择你感兴趣的课程类别，开始你的学习之旅</p>
        </div>
        
        <div class="categories-grid" v-if="catagory">
          <div 
            class="category-card" 
            v-for="(item, index) in catagory" 
            :key="index"
            @click="goToCategory(item.id)"
          >
            <div class="category-icon">
              <img src="../assets/images/icon-course-005.png" :alt="item.name">
            </div>
            <div class="category-content">
              <h3 class="category-name">{{ item.name }}</h3>
              <p class="category-desc">精选课程，专业指导</p>
            </div>
            <div class="category-arrow">›</div>
          </div>
        </div>
        
        <div class="loading-container" v-else>
          <div class="loading-spinner"></div>
          <p>{{ loading }}</p>
        </div>
      </div>
    </section>

    <!-- PC端特色内容 -->
    <section class="pc-features" id="about">
      <div class="container">
        <!-- 继续观看 -->
        <div class="continue-section" v-if="lastVideo">
          <div class="section-header">
            <h2 class="section-title">继续学习</h2>
            <p class="section-desc">上次看到这里，继续你的学习之旅</p>
          </div>
          <div class="continue-card" @click="goToVideo(lastVideo)">
            <div class="continue-card-body">
              <h3 class="continue-card-title">{{ lastVideo.video_name }}</h3>
              <button class="continue-btn">继续观看 ›</button>
            </div>
          </div>
        </div>

        <div class="features-grid">
          <div class="feature-item">
            <div class="feature-icon">📚</div>
            <h3>海量课程</h3>
            <p>丰富的课程资源，满足不同学习需求</p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">👨‍🏫</div>
            <h3>专业师资</h3>
            <p>经验丰富的老师，提供专业教学</p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">🎯</div>
            <h3>精准定位</h3>
            <p>针对性强，助力快速提升</p>
          </div>
          <div class="feature-item">
            <div class="feature-icon">🤝</div>
            <h3>贴心服务</h3>
            <p>全程备考指导，助力顺利上岸</p>
          </div>
        </div>
      </div>
    </section>

    <!-- PC端页脚 -->
    <footer class="pc-footer" id="concat">
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <h3>关于我们</h3>
            <p>致力于为学习者提供优质的在线教育资源，助力每个人实现学习目标。</p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2025 ShangAn. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HomePC',
  props: {
    slider: {
      type: Array,
      required: true
    },
    catagory: {
      type: Array,
      default: () => []
    },
    loading: {
      type: String,
      default: ''
    },
    lastVideo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      currentSlide: 0,
      slideInterval: null
    };
  },
  computed: {
    ...mapState({
      userName: state => state.user && state.user.name
    })
  },
  mounted() {
    this.startSlideInterval();
  },
  beforeDestroy() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  },
  methods: {
    startSlideInterval() {
      this.slideInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slider.length;
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.slider.length) % this.slider.length;
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    goToCategory(id) {
      this.$router.push(`/list/${id}`);
    },
    goMine() {
      if (this.userName) {
        this.$router.push('/mine');
      } else {
        this.$router.push('/login');
      }
    },
    goToVideo(video) {
      this.$router.push(`/video/${video.video_id}/1?categoryId=${video.category_id || ''}`);
    }
  }
};
</script>

<style>
@import "../assets/stytels/home-pc.css";

.continue-section {
  margin-bottom: 40px;
}

.continue-card {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 12px;
  padding: 24px 32px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.continue-card:hover {
  transform: translateY(-2px);
}

.continue-card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.continue-card-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}

.continue-btn {
  font-size: 14px;
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  padding: 8px 20px;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 500;
}

.continue-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}
</style>

